import { FragmentType, graphql, useFragment } from '@/generated/gql'
import { CanteenCartItemInput } from '../MenuCart/types'
import { numberFormat } from '@/helpers/numbers'

export const cartMappingItemDataFragment = graphql(`
  fragment CartMapping_ItemDataFragment on CCMenuItem {
    id
    submenuId
    vendorLocationId
    liveMenuItem {
      _id
      name
      image
      variations {
        _id
        type
        priceCustomerFacing
        varType
      }
    }
  }
`)

export type CartMappingOptionInput = {
  item: {
    id: string
    price: number
    name: string
  }
  category: {
    id: string
  }
}

export const graphqlDataToCartItem = (
  gqlItem: FragmentType<typeof cartMappingItemDataFragment>,
  itemData: { quantity: number; ccVariationId: string },
  optionData: CartMappingOptionInput[],
): CanteenCartItemInput => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { liveMenuItem, submenuId, vendorLocationId } = useFragment(
    cartMappingItemDataFragment,
    gqlItem,
  )
  if (!liveMenuItem) throw new Error('Invalid item, no item')
  const { variations } = liveMenuItem
  const ccVariation = variations?.find((variation) => variation._id === itemData.ccVariationId)
  if (!ccVariation) throw new Error('Invalid item, no ccVariation')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return {
    name: liveMenuItem.name || '',
    supplierLocationId: Number(vendorLocationId),
    id: liveMenuItem._id,
    itemId: ccVariation._id,
    submenuId: Number(submenuId),
    qty: itemData.quantity,
    item: {
      name: liveMenuItem.name || '',
      image: liveMenuItem.image || '',
      price: numberFormat((ccVariation.priceCustomerFacing || 0) / 100, 2),
      type: ccVariation.type || '',
    },
    options: optionData.map((option) => {
      return {
        id: option.item.id,
        name: option.item.name,
        price: numberFormat((option.item.price || 0) / 100, 2),
        option: {
          id: option.category.id,
        },
      }
    }),
  }
}
